<template>
  <v-dialog
    v-model="dialog"
    max-width="800px"
  >
    <template v-slot:activator="{ on:dialog }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn
            text
            icon
            color="warning"
            x-small
            v-on="{ ...dialog, ...tooltip }"
          >
            <v-icon>
              mdi-information-outline
            </v-icon>
          </v-btn>
        </template>
        <span>View Position History</span>
      </v-tooltip>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      :loading="loading"
      color="hrissecondary"
      title="Employee Positions"
      text="List of Employee Position Records"
      class="mb-0"
    > 
      <v-skeleton-loader
        v-if="loading"
        type="list-item"
      />
      <v-data-table
        v-else
        :headers="positionHistoryHeaders"
        :items="positions"
        disable-pagination
        hide-default-footer
        dense
        class="mt-5 mb-0"
        :style="`border:1px solid rgba(0,0,0,.12)`"
      >
        <template v-slot:item.position="{ item }">
          <div>  
            <span>
              {{ item.position.name }}
            </span>
          </div>
        </template>

        <template v-slot:item.start_date="{ item }">
          <div>
            <v-skeleton-loader
              v-if="loading"
              type="list-item"
            />  
            <span v-else>
              {{ item.start_date ? $moment(item.start_date).format('D MMM YYYY') : 'N/A' }}
            </span>
          </div>
        </template>

        <template v-slot:item.end_date="{ item }">
          <div>
            <v-skeleton-loader
              v-if="loading"
              type="list-item"
            />  
            <span v-else>
              {{ item.end_date ? $moment(item.end_date).format('D MMM YYYY') : 'N/A' }}
            </span>
          </div>
        </template>

        <template 
          v-slot:item.action="{ item }"
        >
          <div>
            <employee-profile-job-dialog-edit-position-record
              v-if="$hasPermissionTo(['update employee position']) && !isMyProfile && !isResigned"
              :index="item.index"
              :position-record="item"
              :min-start-date="item.index === positions.length - 1 || !(positions[item.index + 1].end_date) ? joinDate : $moment(positions[item.index + 1].end_date).format('YYYY-MM-DD')"
              :max-end-date="item.index > 0 ? $moment(positions[item.index - 1].start_date).format('YYYY-MM-DD') : ''"
              @updated="loadData()"
            /> 
          </div>
        </template>
      </v-data-table>
    </material-card> 
  </v-dialog>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    components: {
      EmployeeProfileJobDialogEditPositionRecord: () => import('@/components/hris/employee/profile/job/DialogEditPositionRecord'),
    },
    props: {
      employeeUid: {
        type: String,
        default: '',
      },
      joinDate: {
        type: String,
        required: true,
      },
      isResigned: {
        type: Boolean,
        required: true,
      },
    },
    data () {
      return {
        dialog: false,
        loading: false,
        positions: [],
        positionHistoryHeadings: [
          {
            text: 'Position', 
            sortable: false, 
            value: 'position.name',
            divider: true,
            width: 220,
          },
          {
            text: 'Start Date',
            sortable: false,
            value: 'start_date',
            divider: true,
            width: 120,
            align: 'center',
          },  
          {
            text: 'End Date', 
            sortable: false, 
            value: 'end_date',
            divider: true,
            width: 120,
            align: 'center',
          },                   
        ],
      }
    },
    computed: {
      ...mapState({ isCurrentUser: 'isMyProfile' }),
      isMyProfile () {
        return this.$store.state.isMyProfile
      },
      positionHistoryHeaders () {
        let originalTab = [...this.positionHistoryHeadings]
        if (this.$hasPermissionTo(['update employee position']) && !this.isMyProfile && !this.isResigned) {
          originalTab.splice(originalTab.length, 0, {
            text: '',
            sortable: false,
            align: 'center',
            value: 'action',
            width: 50,
          })
        }

        return originalTab
      },
    },
    watch: {
      employeeUid: {
        immediate: true,
        handler (newVal, oldVal) {
          if (!_.isEmpty(newVal)) {
            this.loadData()
          }
        },
      },
    },
    methods: {
      loadData () {
        this.loading = true

        this.$api.hrisEmployeePositions().list(this.employeeUid)
          .then(res => {
            this.positions = _.orderBy(res.data, ['created_at'], ['desc'])

            this.positions = this.positions.map((item, index) => ({
              index: index,
              ...item,
            }))

            this.loading = false
          })
      },
    },
  }
</script>

<style lang="css" scoped>
.preline{
  white-space: pre-line
}

.flex-button{
 display: flex;
 flex-direction: row;
 margin: auto;
}
</style>
